import MasterService from "./MasterService";

const InsuranceService = {
    ...MasterService,

    getInsuranceListing(params: object) {
        return this.post('/lead/adminLeadList', params)
    },

    updateLeadAssignUser(params: object) {
        return this.post('/lead/updateLeadAssignUser', params)
    },

    fetchLeadProcessingDetails(params: object) {
        return this.post('/lead/fetchLeadProcessingDetails', params)
    },

    fetchLeadProcessingEmiDetails(params: object) {
        return this.post('/lead/fetchLeadProcessingEmiDetails', params)
    },
    
    getLeadHistory(params: object) {
        return this.post('/lead/getLeadHistory', params)
    },

    updatePaymentMethod(params: object) {
        return this.post('/lead/updatePaymentMethod', params)
    },
    updateLeadEmiDetail(params: object) {
        return this.post('/lead/updateLeadEmiDetail', params)
    },

    changeFollowupStatus(params: object) {
        return this.post('/lead/updateFollowupStatus', params)
    },

    sendForReferralPayout(params: object) {
        return this.post('/lead/sendForReferralPayout', params)
    },
    getReferralPayout(params: object) {
        return this.post('/lead/getReferralPayout', params)
    },
    updateLeadPaymentConfig(params: object) {
        return this.post('/lead/updateLeadPaymentConfig', params)
    },
    bulkLeadAssignee(params: object){
        return this.post('/lead/bulkLeadAssignee',params)
    },
    triggerPaymentEmail(params: object) {
        return this.post('/lead/triggerPaymentMail', params)
    },
    downLoadQrCode(params: object) {
        return this.post('/lead/downloadQrCode', params)
    },

    offsetAgentCommission(params: object) {
        return this.post('/lead/offsetAgentCommission', params)
    },
}

export default InsuranceService;